import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-989a7c02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trigger" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "分享链接", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"margin-top":"25px"} }, "手机扫码查看", -1))

import QRCode from "qrcode";
import { ref } from "vue";

interface Props {
  shareLink: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareTrigger',
  props: {
    shareLink: { default: () => {
    return "";
  } }
  },
  setup(__props: any) {

const props = __props;

const codeImg = ref();
// 分享链接
const link =
  props.shareLink == ""
    ? `${window.location.href}`
    : `${"https://" + window.location.host}/${props.shareLink}`;
const shareLink = `${link}`;
// 分享

/**
 * 生成二维码
 */
QRCode.toDataURL(link)
  .then((url: any) => {
    codeImg.value = url;
  })
  .catch((err: any) => {
    console.error(err);
  });

return (_ctx: any,_cache: any) => {
  const _component_icon_share_alt = _resolveComponent("icon-share-alt")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_trigger = _resolveComponent("a-trigger")!

  return (_openBlock(), _createBlock(_component_a_trigger, { trigger: "click" }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_a_typography_paragraph, { copyable: "" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(shareLink))
          ]),
          _: 1
        }),
        _hoisted_3,
        _createVNode(_component_a_image, { src: codeImg.value }, null, 8, ["src"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", null, [
        _createVNode(_component_icon_share_alt),
        _createVNode(_component_a_typography_text, null, {
          default: _withCtx(() => [
            _createTextVNode(" 分享 ")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})